import React, { useEffect, useState } from "react";
import { getFetch, postFetch } from "../../../../../../fetch/fetch";
import { DataGridPremium, GridRowModel } from "@mui/x-data-grid-premium";
import { Button, IconButton, Modal, ModalDialog } from "@mui/joy";
import { Add, Delete } from "@mui/icons-material";
import { dateToDateString } from "../../../etc/etcfunctions";
import AddDefaultWorkSettingModal from "./adddefaultworksettingmodal";
import { englishLocationToKorean } from "../../../../../../data/locationFuntion";

const DefaultWorkSettingModal: React.FC<any> = (props) => {

    const [rows, setRows] = useState<any[]>([]);
    const [columns, setColumns] = useState<any[]>([
        { field : "location", headerName : "기본 근무 지점", width : 200 },
        { field: "korean", headerName: "기본 근무 종류", width: 400 },
        { field: "author", headerName: "작성자", width: 150 },
        { field: "createdAt", headerName: "작성일", width: 200 },
        {
            field: "delete", headerName: "삭제", width: 100, renderCell: (params: any) => {

                const id = params.row.id;

                const deleteWorkSetting = async () => {
                    try {
                        if (!id) {
                            return;
                        }

                        if (!window.confirm("정말로 메모를 삭제하시겠습니까?")) {
                            return;
                        }

                        setLoading(true);

                        const result: any = await postFetch("/dashboard/salary/deleteworksetting", {
                            id,
                        });

                        setLoading(false);

                        if (result.message === "success") {
                            setUpdate(Math.random());
                        }

                    } catch (e) {
                        console.log(e);
                    }
                };

                return (
                    <div>
                        <IconButton
                            onClick={deleteWorkSetting}
                        >
                            <Delete />
                        </IconButton>
                    </div>
                )

            }
        }
    ]);
    const [update, setUpdate] = useState(0);
    const [loading, setLoading] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);

    useEffect(() => {
        
        if (props.open) {
            getDefaultWorkSettings();
        }

    }, [props.open, update]);


    const getDefaultWorkSettings = async () => {

        try {

            setLoading(true);

            const result : any = await getFetch("/dashboard/salary/getdefaultworksettings?userId=" + props.user.id);


            if(result.message === "success"){
            
                const data = result.data;

                const newRows : any[] = [];

                data.forEach((item : any) => {

                    const newRow : any = {};

                    newRow.id = item.id;
                    newRow.location = englishLocationToKorean(item.location);

                    const location = item.location;

                    const data = props.data;

                    const selectedJob = data[location].jobs.find((jobItem: any) => jobItem.english === item.english);

                    newRow.english = item.english;
                    newRow.korean = selectedJob.korean;
                    newRow.author = item.authorName;
                    newRow.createdAt = dateToDateString(new Date(item.createdAt));

                    newRows.push(newRow);


                });

                setRows([...newRows]);

            }

            setLoading(false);

        } catch (e) {
            console.log(e);
        }
        
    }


    return (
        <div>
            <Modal
                open={props.open}
                onClose={props.onClose}
            >
                <ModalDialog>
                    <div>
                        <div style={{
                            fontSize: "18px",
                            fontWeight: 600,
                            marginBottom: "15px",
                            display: "flex",
                            justifyContent: "space-between"
                        }}>
                            <div>
                                기본 근무 설정
                            </div>
                            <div>
                                <Button
                                    variant="outlined"
                                    onClick={() => setModalOpen(true)}
                                >
                                    기본 근무 추가하기
                                </Button>
                            </div>
                        </div>
                        <div style={{
                            height : "400px",
                            width : "100%"
                        }}>
                            <DataGridPremium
                                rows={rows}
                                columns={columns}
                                loading={loading}
                                density="compact"
                                hideFooter={true}
                            />
                        </div>
                    </div>
                </ModalDialog>
            </Modal>

            <AddDefaultWorkSettingModal
                open={modalOpen}
                onClose={() => setModalOpen(false)}
                user={props.user}
                notify={props.notify}
                setUpdate={props.setUpdate}
                data={props.data}
                setUpdate2={setUpdate}
            />
        </div>
    )
}

export default DefaultWorkSettingModal;